import TextReview from "./TextReview";
import TextStar from "./TextStar";
import DotB from "./dotB";
import TextHost from "./textHost";
import TextHost2 from "./textHost2";
import TextReview2 from "./textReview2";
import TextStar2 from "./textStar2";
import TextStar3 from "./textStar3";

export default function TextAmini() {
  return (
    <div className="flex justify-start color222 7:font-semibold text-c12  ">
      <TextStar3 />
      <DotB />
      <TextReview2 />
      <DotB />
      <TextHost2 />
    </div>
  );
}
